import React from 'react';
import PropTypes from 'prop-types';

import './FooterSub.scss';

const FooterSubItem = ({ companyLinkUrl, companyLinkText }) => (
  <li>
    <FooterSubItem.Tag companyLinkUrl={companyLinkUrl}>
      {companyLinkText}
    </FooterSubItem.Tag>
  </li>
);

FooterSubItem.Tag = ({ companyLinkUrl, children }) => {
  if (companyLinkUrl) {
    return <a href={companyLinkUrl}>{children}</a>;
  }

  return children;
};

const FooterSub = props => (
  <div className="FooterSub">
    <div className="container-guttered">
      <nav className="FooterSub__sub-links">
        <ul>
          {props.companyLinks.map(link => (
            <FooterSubItem key={link.companyLinkUrl} {...link} />
          ))}
        </ul>
      </nav>
    </div>
  </div>
);

FooterSubItem.Tag.propTypes = {
  companyLinkUrl: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FooterSubItem.propTypes = {
  companyLinkUrl: PropTypes.string,
  companyLinkText: PropTypes.string.isRequired,
};

FooterSub.propTypes = {
  companyLinks: PropTypes.arrayOf(
    PropTypes.shape(FooterSubItem.propTypes),
  ).isRequired,
};

export default FooterSub;
